import { FC } from 'react';
import { Fab, Tooltip } from '@mui/material';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { useZohoSalesIQ } from '@host/hooks/zohoSalesIQ.hook';

/** Floating support entry for logged-out flows (welcome, signup, park). */
export const ZohoSupportFab: FC = () => {
  const { loadZohoSalesIQ } = useZohoSalesIQ();

  return (
    <Tooltip title='Need Help' placement='left' arrow>
      <Fab
        color='primary'
        aria-label='Open support chat'
        onClick={() => void loadZohoSalesIQ()}
        sx={{
          position: 'fixed',
          bottom: 9.5,
          right: 9.5,
          zIndex: 10050,
        }}
      >
        <LiveHelpIcon />
      </Fab>
    </Tooltip>
  );
};

export default ZohoSupportFab;
